import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';

import { useHttpUtils } from '../../../Utilities/useHttpUtils';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import useAlert from '../../../Alerts/useAlert';
import usePrivileges from '../../../Auth/usePrivileges';

import CommentDialog from "../../../Dialogs/CommentDialog";

interface ResendReleaseSampleButtonProps {
    setLoading: Dispatch<SetStateAction<boolean>>
}

function ResendReleaseSampleButton({ setLoading }: ResendReleaseSampleButtonProps) {

    const { t } = useTranslation();
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();

    const { lotDetail: {
        summary: {
            lotNumber,
            businessUnitCode,
            currentStatus,
            shouldSendReleaseSample
        }
    } } = useContext(LotDetailContext);
    const { supervisor, admin } = usePrivileges(businessUnitCode);

    const [showCommentDialog, setShowCommentDialog] = useState<boolean>(false);

    const handleSendReleaseSample = async (comment: string) => {
        setLoading(true);
        await fetchDataAuthenticated(`api/v1/lot/${lotNumber}/sendReleaseSample`, 'POST', JSON.stringify(comment))
            .then(async response => {
                if (response.ok) {
                    setAlert("success", "Success", "Release Sample successfully sent to Sample Manager");
                } else {
                    let errorMessage = await response.text();
                    throw new Error("Failed to resend the release sample: " + errorMessage);
                }
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            <Button variant="primary"
                onClick={() => setShowCommentDialog(true)}
                disabled={!supervisor && !admin}
                hidden={currentStatus !== "Graded" || !shouldSendReleaseSample}>
                {t('LotDetails.Summary.ResendReleaseSample')}
            </Button>
            <CommentDialog
                showDialog={showCommentDialog}
                closeDialog={() => setShowCommentDialog(false)}
                onSave={handleSendReleaseSample} />
        </>
    );
}

export default ResendReleaseSampleButton;